import { useMutation, useQueryClient } from "@tanstack/react-query";
// Toastify
import { toast } from "react-toastify";
// API
import API from "./Api";

const markAsShipped = async (id) => {
  const res = await API.post(`api/toggle-is-shipped/${id}`);
  return res.data;
};

export default function useEditIsShippedApi() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: markAsShipped,
    onSuccess: () => {
      // Invalidate and refetch
      // queryClient.invalidateQueries({ queryKey: ["AllOrders"] });
      //   toast.success("Success!");
    },
    onError: (err) => {
      console.error("Error marking as shipped:", err);
      const errorMessage = err?.response?.data?.message || err?.message || "An error occurred";
      // Toastify
      toast.error(errorMessage);
    },
  });
}
